const typographySizes = {
  // Text sizes with mobile variants
  text: {
    extraSmall: {
      size: { mobile: 0.8, desktop: 0.8 },
      lineHeight: 1,
    },
    small: {
      size: { mobile: 1, desktop: 1.2 },
      lineHeight: 1,
    },
    body: {
      size: { mobile: 1.4, desktop: 1.5 },
      lineHeight: 1.2,
    },
    medium: {
      size: { mobile: 1.8, desktop: 2.2 },
      lineHeight: 1,
    },
    large: {
      size: { mobile: 1.8, desktop: 3.2 },
      lineHeight: 1,
    },
  },
  // Heading sizes with mobile variants
  heading: {
    extraSmall: {
      size: { mobile: 1.2, desktop: 1.4 },
      lineHeight: 1,
    },
    extraSmall2: {
      size: { mobile: 2.2, desktop: 2.2 },
      lineHeight: 1,
    },
    small: {
      size: { mobile: 3.2, desktop: 3.2 },
      lineHeight: 0.9,
    },
    medium: {
      size: { mobile: 4, desktop: 4 },
      lineHeight: 0.95,
    },
    large: {
      size: { mobile: 3.6, desktop: 5.6 },
      lineHeight: 0.8,
    },
    extraLarge: {
      size: { mobile: 4.2, desktop: 9 },
      lineHeight: 0.7,
    },
  },
};

export default typographySizes;
